import { useDispatch } from 'react-redux';
import { toast } from './toastActions';

export function useToast() {
  const dispatch = useDispatch();
  return {
    success: (message: string) => dispatch(toast.success(message)),
    error: (message: string) => dispatch(toast.error(message)),
    warning: (message: string) => dispatch(toast.warning(message)),
    info: (message: string) => dispatch(toast.info(message)),
    hide: (id?: string) => dispatch(toast.hide(id)),
    hideAll: () => dispatch(toast.hideAll()),
  };
}
